import { forwardRef } from 'react';

import type { IconProps } from './types';

const BlockAudio = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="M1023.999 510.667c0-152.889-96-288-241.778-337.778-10.667-3.555-21.333 3.555-24.889 10.667-3.555 10.667 3.555 21.333 10.667 24.889 131.555 42.667 216.889 167.111 216.889 305.778s-88.889 259.555-216.889 305.778c-10.667 3.555-14.222 14.222-10.667 24.889 3.555 7.111 10.667 14.222 17.778 14.222h7.111c142.222-56.889 241.778-192 241.778-348.445z"
      fill={color}
    />
    <path
      d="M888.887 510.667c0-110.222-74.667-206.222-177.778-238.222-10.667-3.555-21.333 3.555-21.333 14.222-3.555 10.667 3.555 21.333 14.222 21.333 88.889 24.889 152.889 110.222 152.889 202.667s-64 177.778-152.889 202.667c-10.667 3.555-14.222 14.222-14.222 21.333 3.555 7.111 10.667 14.222 17.778 14.222h3.555c103.111-28.445 177.778-128 177.778-238.222zM522.666 98.222c-17.778-10.667-39.111-10.667-56.889 0h-3.555L213.333 308H17.778C7.111 308 0 315.111 0 325.778v348.445c0 3.555 3.555 10.667 7.111 14.222s7.111 7.111 14.222 7.111h195.555l248.889 227.555s3.555 0 3.555 3.555c10.667 7.111 17.778 7.111 28.445 7.111s17.778-3.555 28.445-7.111c17.778-10.667 28.445-28.445 28.445-49.778V147.999c-3.555-21.333-14.222-39.111-32-49.778zm-7.112 778.667c0 7.111-3.555 14.222-10.667 17.778-3.555 0-10.667 3.555-17.778 0L241.776 667.112v-85.333c0-10.667-7.111-17.778-17.778-17.778s-17.778 7.111-17.778 17.778v74.667H39.109V343.557H206.22v252.445c0 10.667 7.111 17.778 17.778 17.778s17.778-7.111 17.778-17.778V332.891l245.333-209.778c7.111-3.555 14.222 0 17.778 0 7.111 3.555 10.667 10.667 10.667 17.778z"
      fill={color}
    />
  </svg>
));

export default BlockAudio;
